import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { GeneralDropdown } from "../../../../components/components/js/GeneralDropdown";
import { downloadPDF } from "../../../../utils/exportUtils";
import { IndividualReport } from "./IndividualReport";
import { ComparativeReport } from "./ComparativeReport";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";

export const QuranReport = () => {
  const { t,i18n } = useTranslation();
  const trans_prefix = "admin_pages.quran_report";
  const trans = {
    title: t("admin_titles.quran_report"),
    export_pdf: t("buttons.export_pdf"),
    individual_report: t(`${trans_prefix}.report_types.individual`),
    comparative_report: t(`${trans_prefix}.report_types.comparative`),
  };

  const reportTypes = [
    { value: "individual", label: trans.individual_report },
    // { value: "comparative", label: trans.comparative_report },
  ];

  const getInitialReportType = () => {
    // if there it's in the hash, get it, else, get the first one in the reportTypes array
    const hash = window.location.hash.replace("#", "");
    return reportTypes.find(r => r.value === hash) || reportTypes[0];
  };

  const [selectedReportType, setSelectedReportType] = useState(getInitialReportType);
  const individualReportRef = useRef();
  const comparativeReportRef = useRef();

  const handleReportTypeChange = (option) => {
    setSelectedReportType(option);

    // Update the hash when the user selects a report
    window.location.hash = option.value;
  };

  const printDirection = i18n.dir(); 

  // ── react-to-print: واحد لكل نوع تقرير ──────────────────────────────
  const printIndividual = useReactToPrint({
      contentRef: individualReportRef,
      documentTitle: "activity_report",
      // مهم جدًا: نضمن إن نافذة الطباعة بتاخد اتجاه RTL والـ fonts صحيحة
      pageStyle: `
        @page { size: A4; margin: 10mm; }
        @media print {
          body { direction: ${printDirection}; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `,
    });


  const printComparative = useReactToPrint({
    contentRef: comparativeReportRef,
    documentTitle: "activity_report",
    pageStyle: `
      @page { size: A4; margin: 10mm; }
      @media print {
        body { direction: ${printDirection}; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
  });

  const handleDownloadPDF = () => {
    if (selectedReportType.value === "comparative") {
      printComparative();
    } else {
      printIndividual();
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-4">
        <div className="d-flex gap-4">
          <h3>{trans.title}</h3>
          <GeneralDropdown
            placeholder={"Report Type"}
            options={reportTypes}
            selectedOption={selectedReportType}
            onChange={handleReportTypeChange}
            backgroundColor={"#eee"}
            width={"11rem"}
            noBorder
          />
        </div>
        <Button
          onClick={handleDownloadPDF}
          className="fw-bold purple-text-color bg-transparent border-0 no-hover-bg"
        >
          {trans.export_pdf}
        </Button>
      </div>

      {selectedReportType.value === "individual" ? (
        <IndividualReport reportRef={individualReportRef} />
      ) : (
        <ComparativeReport reportRef={comparativeReportRef} />
      )}
    </>
  );
};
